import { $ajaxService } from './request'
import { service } from './request'

/**
 * 任务列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/hxe1lx/edit?toc_node_uuid=miE9LYqnXeJ47uy9#P8ltl
 * @param  {} member_userid 成员id
 * @param  {} customer_userid 客户userid
 * @param  {} page
 * @param  {} page_size
 */
export const getMarketingTaskList = ({
  member_userid,
  customer_userid,
  chat_id,
  page,
  page_size
}) =>
  $ajaxService.post($ajaxService.baseUrl + 'task/sendor_task_list', {
    member_userid,
    customer_userid,
    chat_id,
    page,
    page_size
  })

/**
 * 任务详情 https://paas-teamwork.yuque.com/oundy7/vrp0sx/hxe1lx/edit?toc_node_uuid=miE9LYqnXeJ47uy9#P8ltl
 * @param  {} record_id 任务id
 */
export const getMarketingTaskDetail = ({
  record_id,
  task_id,
  external_userid
}) =>
  $ajaxService.post($ajaxService.baseUrl + 'task/sendor_task_detail', {
    record_id,
    task_id,
    external_userid
  })

/**
 * 记录被编辑过的任务 https://paas-teamwork.yuque.com/oundy7/vrp0sx/qrc1ag#uEOME
 * @param  {} task_id 任务id
 * @param  {} content 编辑的内容文字
 * @param  {} annex_content_json string	内容的资源
 */
export const recordEditTask = ({
  task_id,
  content,
  annex_content_json,
  external_userid
}) =>
  $ajaxService.post($ajaxService.baseUrl + 'task/send/edit', {
    task_id,
    content,
    annex_content_json,
    external_userid
  })

/**
 * 获取待执行任务总数 https://paas-teamwork.yuque.com/oundy7/vrp0sx/hxe1lx/edit?toc_node_uuid=miE9LYqnXeJ47uy9#P8ltl
 * @param  {} member_userid 成员id
 * @param  {} customer_userid 客户userid
 */
export const getTaskcount = ({ member_userid, customer_userid, chat_id }) => {
  // console.log('掉借口前打印', customer_userid)
  return $ajaxService.post($ajaxService.baseUrl + 'task/sendor_task_count', {
    member_userid,
    customer_userid,
    chat_id
  })
}
/**
 * 成员转发信息之后回传状态 https://paas-teamwork.yuque.com/oundy7/vrp0sx/hxe1lx/edit?toc_node_uuid=miE9LYqnXeJ47uy9#P8ltl
 * @param  {} send_record_son_id 子任务id
 * @param  {} member_userid 成员userid
 * @param  {} external_userid 客户（外部）userid
 * @param  {} send_status 发送状态
 */
export const backTaskStatus = ({
  send_record_son_id,
  member_userid,
  external_userid,
  send_status
}) =>
  $ajaxService.post($ajaxService.baseUrl + 'task/sendor_execute_new', {
    send_record_son_id,
    member_userid,
    external_userid,
    send_status
  })

//  ==========================知识库部分=================================================
/**
 * 知识库分组列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/rpuv8f#GoeTd
 * @param  {} type 分组查询类型：0=知识库分组查询  ； 1=推荐回复分组查询（返回关键词数量）  ；不传递默认为0
 * @param  {} get_sale_script_num 是否获取分组下的知识数量 ：0=不获取；1=获取；不传递默认为0
 * @param  {} search_content string	筛选知识内容
 * @param  {} search_group_name 筛选知识分组名称
 */
export const getGroupList = ({
  type,
  get_sale_script_num,
  search_content,
  search_group_name
}) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_group/get_group_list',
    {
      type,
      get_sale_script_num,
      search_content,
      search_group_name
    }
  )

/**
 * 获取知识库话术列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/rpuv8f#GoeTd
 * @param  {} group_id 分组id
 * @param  {} search_content 筛选文本内容
 */
export const getKnowledgeList = ({ group_id, search_content }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script/get_sale_script_list',
    {
      group_id,
      search_content
    }
  )

/**
 * 获取知识库话术详情 https://paas-teamwork.yuque.com/oundy7/vrp0sx/rpuv8f#GoeTd
 * @param  {} sale_script_id 话术id
 */
export const getKnowledgeDetail = ({ sale_script_id }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script/get_sale_script_detail',
    {
      sale_script_id
    }
  )

/**
 * 话术发送统计(个人话术) https://paas-teamwork.yuque.com/oundy7/vrp0sx/rpuv8f#GoeTd
 * @param  {} sale_script_id 话术id
 */
export const backPersonalSend = ({ sale_script_id }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script/add_sale_script_send_num',
    {
      sale_script_id
    }
  )
// ==============================================================推荐回复模块==========================================================================================
/**
 * 获取推荐回复会话列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/abdx1v#KJ6Dg
 * @param  {} chat_id 群聊id （chat_id 和customer_id 二选一填一个）
 * @param  {} customer_id 客户id
 */
export const getRecommandList = ({ chat_id, customer_id }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script/get_recommend_reply_list',
    {
      chat_id,
      customer_id
    }
  )

/**
 * 获取推荐回复匹配的话术列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/abdx1v#TkK8U
 * @param  {} work_message_id 推荐回复消息id
 */
export const getRecommandSpeechList = ({ work_message_id }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script/get_recommend_sale_script_list',
    {
      work_message_id
    }
  )

// ========================================================个人（我的）话术================================================
/**
 * 获取个人话术列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lf2fcg#VrQB0
 * @param  {} page_num 分页页码
 * @param  {} page_size 分页大小
 * @param  {} search_content 搜索内容
 */
export const getSpeechList = ({ page_num, page_size, search_content }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_personal/get_sale_script_list',
    {
      page_num,
      page_size,
      search_content
    }
  )

/**
 * 添加个人话术 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lf2fcg#VgUov
 * @param  {} content 话术内容
 */
export const addPersonalSpeech = ({ content }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_personal/add_sale_script',
    {
      content
    }
  )

/**
 * 编辑个人话术 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lf2fcg#VgUov
 * @param  {} sale_script_id 话术ID
 * @param  {} content 话术内容
 */
export const editPersonalSpeech = ({ sale_script_id, content }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_personal/update_sale_script',
    {
      sale_script_id,
      content
    }
  )

/**
 * 个人话术拖拽排序 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lf2fcg#p8ymV
 * @param  {} sale_script_list 新的话术分组排序
 * @param  {} sale_script_list.sale_script_id 话术ID
 * @param  {} sale_script_list.sort 新的话术排序，正序 1,2,3,4...
 */
export const changeSpeechsSort = ({ sale_script_list }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_personal/update_sale_script_sort',
    {
      sale_script_list
    }
  )

/**
 * 删除个人话术 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lf2fcg#VgUov
 * @param  {} sale_script_id 话术ID
 */
export const deletePersonalSpeech = ({ sale_script_id }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_personal/delete_sale_script',
    {
      sale_script_id
    }
  )

// =====================================================标签营销============================================
/**
 * 获取推荐的标签营销列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lyoogp#KJ6Dg
 * @param  {} external_userid 企微外部联系人id
 */
export const getMaketingLabelList = ({ external_userid }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_tag/get_tag_list',
    {
      external_userid
    }
  )

/**
 * 获取标签营销匹配的话术列表 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lyoogp#TkK8U
 * @param  {} tag_id_arr 标签id
 */
export const getLabelSpeechList = ({ tag_id_arr }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_tag/get_tag_sale_script_list',
    {
      tag_id_arr
    }
  )

/**
 * 获取标签营销详情 https://paas-teamwork.yuque.com/oundy7/vrp0sx/lyoogp#TkK8U
 * @param  {} sale_script_id 会话id
 */
export const getMarketingLabelDetail = ({ sale_script_id }) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'guide/sale_script_tag/get_sale_script_detail',
    {
      sale_script_id
    }
  )

/**
 * 记录导购端知识/个人话术动态 https://paas-teamwork.yuque.com/oundy7/vrp0sx/fsuxp5#MlZK6
 * @param  {} sale_script_id 会话id
 * @param  {} event_key 类型
 * @param  {} field 客户id或者群id
 * @param  {} field_value 取值为 群id/个人客户id
 * @param  {} tag_idx 标签营销时必传[1,2]
 * @param  {} strategy_id 策略id
 * @param  {} content_key 素材库内容包id
 */
export const setBackSend = ({
  sale_script_id,
  event_key,
  field,
  field_value,
  tag_idx,
  strategy_id,
  content_key
}) =>
  $ajaxService.post($ajaxService.baseUrl + 'sale_script/events_put', {
    sale_script_id: sale_script_id || 0,
    event_key,
    field,
    field_value,
    tag_idx,
    strategy_id,
    content_key
  })

/**
 * 记录导购获取导购memberid https://we-customer.w.eolink.com/home/api_studio/inside/api/detail?apiID=48351566&groupID=1832266&projectHashKey=XIQlMVI1213a36bc20d06967488fe804e9f801782c717ec&spaceKey=we-customer
 */
export const getMemberId = () =>
  $ajaxService.post($ajaxService.baseUrl + 'guide/get_member_id')

/**
 * 记录导购端知识/个人话术动态 https://paas-teamwork.yuque.com/oundy7/vrp0sx/fsuxp5#MlZK6
 * @param  {} payable_id 产生埋点的数据id
 * @param  {} type 分享类型 任务-task 知识-knowledge 标签营销-tag_marketing 推荐回复-reply 成员活码-member_code 个人欢迎-personal 通用欢迎-general 聊天工具栏-chat, goods(b2c商城-商品), coupon(b2c商城-商品)
 * @param  {} user_id 客户userid
 * @param  {} content_key 素材库内容包id
 */
export const sendMonitor = ({ payable_id, type, user_id, content_key }) =>
  $ajaxService.post($ajaxService.baseUrl + 'share_record', {
    payable_id,
    type,
    user_id,
    content_key
  })

/**
 * 获取命中的策略列表 https://we-customer.w.eolink.com/home/api_studio/inside/api/detail?apiID=48745706&groupID=1832266&projectHashKey=XIQlMVI1213a36bc20d06967488fe804e9f801782c717ec&spaceKey=we-customer
 * @param  {} external_userid 外部联系人id
 */
export const getStrategeList = ({ external_userid }) =>
  $ajaxService.post($ajaxService.baseUrl + 'guide/get_stratege', {
    external_userid
  })

/**
 * 客户动作动态接口 https://we-customer.w.eolink.com/home/api_studio/inside/api/detail?apiID=49443794&groupID=2140264&projectHashKey=XIQlMVI1213a36bc20d06967488fe804e9f801782c717ec&spaceKey=we-customer
 * @param  {} event_key 事件标识,成员分享商品给客户-member_share_goods_customer   成员分享积分商品给客户-member_share_score_goods_customer
 * @param  {} field 字段-external_contact
 * @param  {} field_value 字段内容-客户企微id
 * @param  {} relate_id 关联id，例如商品id，积分商品id
 * @param  {} relate_class 关联表，商品-shop_goods，积分商品-score_goods
 */
export const recordCustomerDynamic = ({
  event_key,
  field,
  field_value,
  relate_id,
  relate_class
}) =>
  $ajaxService.post($ajaxService.baseUrl + 'events_dynamic/put', {
    event_key,
    field,
    field_value,
    relate_id,
    relate_class
  })

/**
 * 获取带参数的小程序码 https://we-customer.w.eolink.com/home/api_studio/inside/api/detail?apiID=49434004&groupID=2125468&projectHashKey=XIQlMVI1213a36bc20d06967488fe804e9f801782c717ec&spaceKey=we-customer
 * @param  {} poster_id 海报id
 * @param  {} member_id 成员id,成员表id(非企微id)
 * @param  {} relate_id 相关id,任务海报-任务id,素材海报-素材id
 * @param  {} relate_class 相关类型，任务-task,素材-sale_script，策略-strategy
 */
export const getMiniprogramCode = (body) =>
  $ajaxService.post($ajaxService.baseUrl + 'shop/poster/miniprogram_code', body)

/**
 * 验证商品的上下架状态 https://we-customer.w.eolink.com/home/api_studio/inside/api/detail?apiID=49377316&groupID=2125468&projectHashKey=XIQlMVI1213a36bc20d06967488fe804e9f801782c717ec&spaceKey=we-customer
 * @param  {} poster_id 海报id
 */
export const checkGoodsStatus = (body) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'shop/poster/check_goods_status',
    body
  )

/**
 * 获取海报临时media_id https://we-customer.w.eolink.com/home/api_studio/inside/api/detail?apiID=49465920&groupID=2125468&projectHashKey=XIQlMVI1213a36bc20d06967488fe804e9f801782c717ec&spaceKey=we-customer
 * @param  {} img_base64 海报图片流
 */
export const getPosterMediaId = (body) =>
  $ajaxService.post($ajaxService.baseUrl + 'shop/poster/media_id', body)

/**
 * 记录海报使用情况 https://we-customer.w.eolink.com/home/api_studio/inside/api/detail?apiID=49394381&groupID=2125468&projectHashKey=XIQlMVI1213a36bc20d06967488fe804e9f801782c717ec&spaceKey=we-customer
 * @param  {} img_base64 海报图片流
 */
export const usePosterRecord = (body) =>
  $ajaxService.post(
    $ajaxService.baseUrl + 'shop/poster/add_goods_poster_use',
    body
  )
